"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPinViewCartaConto = exports.resetPanViewCartaConto = exports.copyPanViewCartaConto = exports.copyPanViewSuccess = exports.getPanViewCartaConto = exports.startPanViewScaCartaConto = exports.getPinViewCartaConto = exports.startPinViewScaCartaConto = exports.setTipoDivisaSelezionata = exports.setTipoElencoCartaConto = exports.resetMovimentiHomepage = exports.rimuoviFiltriCartaConto = exports.rimuoviFiltriSaldoMovimenti = exports.resetFiltriMovimenti = exports.resetSaldoEMovimenti = exports.resetMovimenti = exports.getSaldoComplessivo = exports.getParametriCartaConto = exports.setMovimentiSetAccordionFiltriOpened = exports.setMovimentiEntrataUscita = exports.setMovimentiSetEntrateUscite = exports.setMovimentiSetMovimentiNonContabilizzati = exports.setMovimentiSetOrdinamento = exports.setMovimentiSetUscite = exports.setMovimentiSetEntrate = exports.setMovimentiSetPeriodo = exports.setMovimentiSetImporto = exports.setMovimentiSetCategorie = exports.setMovimentiSetDataA = exports.setMovimentiSetDataDa = exports.setMovimentiSetDescrizione = exports.setMovimentiSetOffset = exports.setMovimentiSetRapportoSelezionatoContoDeposito = exports.setMovimentiSetRapportoSelezionato = exports.resetFiltri = exports.esportaDettaglioMovimentoPDF = exports.esportaMovimentiEXCEL = exports.esportaMovimentiPDF = exports.getMovimenti = exports.getMovimentiContoDepositoFiltrati = exports.getMovimentiCartaContoFiltrati = exports.getMovimentiFiltrati = exports.getMovimentiHomepage = exports.getParametriMovimentiContoDeposito = exports.movimentiSwitchToTempParametri = exports.getParametriMovimenti = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const general_types_1 = require("../general/general.types");
const helpers_1 = require("../helpers");
const movimenti_selectors_1 = require("./movimenti.selectors");
/* get parametri movimenti - START */
function getParametriMovimentiStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_START,
    };
}
function getParametriMovimentiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_SUCCESS,
        payload,
    };
}
function generalError(value) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value));
    };
}
function getParametriMovimentiContoDepositoStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_CONTO_DEPOSITO_START,
    };
}
function getParametriMovimentiContoDepositoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_CONTO_DEPOSITO_SUCCESS,
        payload,
    };
}
const getParametriMovimenti = (psd2in = false, loaderEnabled = true) => async (dispatch, _, extraArguments) => {
    loaderEnabled && dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriMovimentiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/parametri_movimenti.json")).then((parametri) => {
            dispatch(getParametriMovimentiSuccess((0, api_rest_1.ParametriMovimentiDtoFromJSON)(parametri)));
            loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem("jwt").then((jwt) => {
            const request = {
                psd2in,
            };
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriMovimenti(request)
                .then((response) => {
                dispatch(getParametriMovimentiSuccess(response));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriMovimenti = getParametriMovimenti;
function movimentiSwitchToTempParametri() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_SWITCH_TO_TEMP_PARAMETRI,
    };
}
exports.movimentiSwitchToTempParametri = movimentiSwitchToTempParametri;
const getParametriMovimentiContoDeposito = (loaderEnabled = true) => async (dispatch, _, extraArguments) => {
    loaderEnabled && dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriMovimentiContoDepositoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/parametri_movimenti.json")).then((parametri) => {
            dispatch(getParametriMovimentiContoDepositoSuccess((0, api_rest_1.ParametriMovimentiDtoFromJSON)(parametri)));
            loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriMovimentiContoDeposito()
                .then((response) => {
                var _a;
                dispatch(getParametriMovimentiContoDepositoSuccess(response));
                ((_a = response.rapporti) === null || _a === void 0 ? void 0 : _a.length) === 0 &&
                    dispatch((0, general_actions_1.setNoRapporti)({ type: general_types_1.TypeNoRapporti.GENERIC }));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriMovimentiContoDeposito = getParametriMovimentiContoDeposito;
/* get parametri movimenti - FINE */
/* get movimenti homepage - START */
function getMovimentiHomepageStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_MOVIMENTI_HOMEPAGE_START,
    };
}
function getMovimentiHomepageSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_MOVIMENTI_HOMEPAGE_SUCCESS,
        payload,
    };
}
const getMovimentiHomepage = (psd2in = false, loaderEnabled = true) => async (dispatch, _, extraArguments) => {
    dispatch(getMovimentiHomepageStart());
    loaderEnabled && dispatch((0, general_actions_1.setLoader)(true));
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/lista_movimenti-homepage.json")).then((parametri) => {
            dispatch(getMovimentiHomepageSuccess((0, api_rest_1.ListaMovimentiDtoFromJSON)(parametri)));
            loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem("jwt").then((jwt) => {
            const request = {
                psd2in,
            };
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getListaMovimentiHome(request)
                .then((response) => {
                dispatch(getMovimentiHomepageSuccess(response));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                loaderEnabled && dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getMovimentiHomepage = getMovimentiHomepage;
/* get movimenti homepage - FINE */
/* get movimenti di saldo e movimenti - START */
function getMovimentiStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_MOVIMENTI_START,
    };
}
function getMovimentiSuccess(payload, offset) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_MOVIMENTI_SUCCESS,
        payload,
        offset,
    };
}
const getMovimentiFiltrati = () => async (dispatch, getState, extraArguments) => {
    const datiForm = (0, movimenti_selectors_1.formElencoMovimentiAsFiltro)(getState().movimenti);
    datiForm &&
        (0, exports.getMovimenti)(datiForm, false)(dispatch, getState, extraArguments);
};
exports.getMovimentiFiltrati = getMovimentiFiltrati;
const getMovimentiCartaContoFiltrati = () => async (dispatch, getState, extraArguments) => {
    const datiForm = (0, movimenti_selectors_1.formElencoMovimentiCartaContoAsFiltro)(getState().movimenti);
    datiForm &&
        (0, exports.getMovimenti)(datiForm, false)(dispatch, getState, extraArguments);
};
exports.getMovimentiCartaContoFiltrati = getMovimentiCartaContoFiltrati;
const getMovimentiContoDepositoFiltrati = () => async (dispatch, getState, extraArguments) => {
    const datiForm = (0, movimenti_selectors_1.formElencoMovimentiContoDepositoAsFiltro)(getState().movimenti);
    datiForm &&
        (0, exports.getMovimenti)(datiForm, false)(dispatch, getState, extraArguments);
};
exports.getMovimentiContoDepositoFiltrati = getMovimentiContoDepositoFiltrati;
const getMovimenti = (datiForm, homepage, forceLoaderEnabled) => async (dispatch, _, extraArguments) => {
    if ((!homepage && (!datiForm.offset || datiForm.offset === 0)) ||
        forceLoaderEnabled) {
        dispatch((0, general_actions_1.setLoader)(true));
    }
    if (datiForm.offset && datiForm.offset > 0) {
        dispatch(setMovimentiListLoader(true));
    }
    dispatch(getMovimentiStart());
    if (!homepage && (!datiForm.offset || datiForm.offset === 0)) {
        dispatch(resetMovimenti());
    }
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/lista_movimenti.json")).then((response) => {
            dispatch(homepage
                ? getMovimentiHomepageSuccess((0, api_rest_1.ListaMovimentiDtoFromJSON)(response))
                : getMovimentiSuccess((0, api_rest_1.ListaMovimentiDtoFromJSON)(response), datiForm.offset));
            if ((!homepage && (!datiForm.offset || datiForm.offset === 0)) ||
                forceLoaderEnabled) {
                dispatch((0, general_actions_1.setLoader)(false));
            }
            if (datiForm.offset && datiForm.offset > 0) {
                dispatch(setMovimentiListLoader(false));
            }
        });
    }
    else {
        const getMovimentiRequest = {
            criteriRicercaMovimentiRequestIn: datiForm,
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getListaMovimenti(getMovimentiRequest)
                .then((response) => {
                dispatch(homepage
                    ? getMovimentiHomepageSuccess(response)
                    : getMovimentiSuccess(response, datiForm.offset));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                if ((!homepage && (!datiForm.offset || datiForm.offset === 0)) ||
                    forceLoaderEnabled) {
                    dispatch((0, general_actions_1.setLoader)(false));
                }
                if (datiForm.offset && datiForm.offset > 0) {
                    dispatch(setMovimentiListLoader(false));
                }
            });
        });
    }
};
exports.getMovimenti = getMovimenti;
/* get movimenti di saldo e movimenti - FINE */
/* esporta PDF lista movimenti - START */
function esportaMovimentiPDFStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_PDF_START,
    };
}
function esportaMovimentiPDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_PDF_SUCCESS,
        payload,
    };
}
const esportaMovimentiPDF = (datiForm, share, title, message) => async (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch(esportaMovimentiPDFStart());
    dispatch((0, general_actions_1.setLoader)(true));
    if (extraArguments.mock) {
        /* TODO: vedere nella parte mockata cosa restituire
                import('../../mock/lista_movimenti.json').then(parametri => {
                  dispatch(esportaMovimentiPDFSuccess(ListaMovimentiDtoFromJSON(parametri)));
                });
                */
    }
    else {
        const requestIn = datiForm || (0, movimenti_selectors_1.formElencoMovimentiAsFiltro)(getState().movimenti);
        const isDeposito = (0, movimenti_selectors_1.formSaldoEMovimenti)(getState().movimenti).isDeposito;
        const isCarta = (0, movimenti_selectors_1.formSaldoEMovimenti)(getState().movimenti).isCarta;
        const rapportoSelezionato = isDeposito
            ? getState().movimenti.form.rapportoSelezionatoContoDeposito
            : getState().movimenti.form.rapportoSelezionato;
        if (requestIn) {
            const esportaMovimentiPDFRequest = {
                type: api_rest_1.ElencoMovimentiPdfTypeEnum.pdf,
                criteriRicercaMovimentiRequestIn: {
                    ...requestIn,
                    contoDeposito: isDeposito,
                    cartaconto: isCarta,
                    saldoContabile: (_a = rapportoSelezionato.saldo) === null || _a === void 0 ? void 0 : _a.saldoContabile,
                    saldoDisponibile: (_b = rapportoSelezionato.saldo) === null || _b === void 0 ? void 0 : _b.saldoDisponibile,
                },
            };
            extraArguments.getItem("jwt").then((jwt) => {
                new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, "application/pdf"))
                    .elencoMovimentiPdf(esportaMovimentiPDFRequest)
                    .then((response) => {
                    if (extraArguments.platform === "desktop") {
                        (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                    }
                    if (extraArguments.platform === "mobile") {
                        (0, helpers_1.download_sharePDF)(extraArguments, "movimenti.pdf", response, share, title, message);
                    }
                    dispatch(esportaMovimentiPDFSuccess(response));
                })
                    .catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                })
                    .finally(() => {
                    dispatch((0, general_actions_1.setLoader)(false));
                });
            });
        }
    }
};
exports.esportaMovimentiPDF = esportaMovimentiPDF;
/* esporta PDF lista movimenti - FINE */
/* esporta EXCEL lista movimenti - START */
function esportaMovimentiEXCELStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_EXCEL_START,
    };
}
function esportaMovimentiEXCELSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_EXCEL_SUCCESS,
        payload,
    };
}
const esportaMovimentiEXCEL = (datiForm, share) => async (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(esportaMovimentiEXCELStart());
    if (extraArguments.mock) {
        /* TODO: vedere nella parte mockata cosa restituire
                import('../../mock/lista_movimenti.json').then(parametri => {
                  dispatch(esportaMovimentiEXCELSuccess(ListaMovimentiDtoFromJSON(parametri)));
                });
                */
    }
    else {
        const requestIn = datiForm || (0, movimenti_selectors_1.formElencoMovimentiAsFiltro)(getState().movimenti);
        const isDeposito = (0, movimenti_selectors_1.formSaldoEMovimenti)(getState().movimenti).isDeposito;
        const rapportoSelezionato = isDeposito
            ? getState().movimenti.form.rapportoSelezionatoContoDeposito
            : getState().movimenti.form.rapportoSelezionato;
        if (requestIn) {
            const esportaMovimentiEXCELRequest = {
                type: api_rest_1.ElencoMovimentiPdfTypeEnum.excel,
                criteriRicercaMovimentiRequestIn: {
                    ...requestIn,
                    contoDeposito: isDeposito,
                    saldoContabile: (_a = rapportoSelezionato.saldo) === null || _a === void 0 ? void 0 : _a.saldoContabile,
                    saldoDisponibile: (_b = rapportoSelezionato.saldo) === null || _b === void 0 ? void 0 : _b.saldoDisponibile,
                },
            };
            extraArguments.getItem("jwt").then((jwt) => {
                new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, "application/vnd.ms-excel"))
                    .elencoMovimentiPdf(esportaMovimentiEXCELRequest)
                    .then((response) => {
                    if (extraArguments.platform === "desktop") {
                        (0, helpers_1.hadleExcelResponse)(response, "movimenti.xlsx");
                    }
                    if (extraArguments.platform === "mobile") {
                        (0, helpers_1.download_shareXLS)(extraArguments, "ElencoMovimenti.xls", response, share);
                    }
                    dispatch(esportaMovimentiEXCELSuccess(response));
                })
                    .catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                })
                    .finally(() => {
                    dispatch((0, general_actions_1.setLoader)(false));
                });
            });
        }
    }
};
exports.esportaMovimentiEXCEL = esportaMovimentiEXCEL;
/* esporta EXCEL lista movimenti - FINE */
/* esporta PDF dettaglio movimento - START */
function esportaDettaglioMovimentoPDFStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_DETTAGLIO_PDF_START,
    };
}
function esportaDettaglioMovimentoPDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_ESPORTA_DETTAGLIO_PDF_SUCCESS,
        payload,
    };
}
//passare anche un obj con codiceRapporto , intestazione , stima
const esportaDettaglioMovimentoPDF = (movimento, share, title, message, criteriPsd2) => async (dispatch, getState, extraArguments) => {
    var _a;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch((0, general_actions_1.setWaitingSection)(true, `PDF${movimento.numeroOperazione}`));
    dispatch(esportaDettaglioMovimentoPDFStart());
    if (extraArguments.mock) {
        /* TODO: vedere nella parte mockata cosa restituire
            import('../../mock/lista_movimenti.json').then(parametri => {
              dispatch(esportaDettaglioMovimentoPDFSuccess(ListaMovimentiDtoFromJSON(parametri)));
            });
            */
    }
    else {
        const isCarta = (0, movimenti_selectors_1.formSaldoEMovimenti)(getState().movimenti).isCarta;
        const isDeposito = (0, movimenti_selectors_1.formSaldoEMovimenti)(getState().movimenti).isDeposito;
        const esportaDettaglioMovimentoPDFRequest = {
            exportMovimentiInDto: {
                movimento: movimento,
                cartaconto: isCarta,
                contoDeposito: isDeposito,
                criteriPsd2: ((_a = movimento.psd2) === null || _a === void 0 ? void 0 : _a.transactionId)
                    ? criteriPsd2
                    : undefined,
            },
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, "application/pdf"))
                .dettaglioMovimentiPdf(esportaDettaglioMovimentoPDFRequest)
                .then(async (response) => {
                if (extraArguments.platform === "desktop") {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === "mobile") {
                    (0, helpers_1.download_sharePDF)(extraArguments, `movimento-${movimento.numeroOperazione}.pdf`, response, share, title, message);
                }
                dispatch(esportaDettaglioMovimentoPDFSuccess(response));
            })
                .catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
                dispatch((0, general_actions_1.setWaitingSection)(false, `PDF${movimento.numeroOperazione}`));
            });
        });
    }
};
exports.esportaDettaglioMovimentoPDF = esportaDettaglioMovimentoPDF;
/* esporta PDF dettaglio movimento - FINE */
function resetFiltri() {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_RESET_FILTRO,
    };
}
exports.resetFiltri = resetFiltri;
function setMovimentiSetRapportoSelezionato(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_SET_RAPPORTO_SELEZIONATO,
        payload: rapportoSelezionato,
    };
}
exports.setMovimentiSetRapportoSelezionato = setMovimentiSetRapportoSelezionato;
function setMovimentiSetRapportoSelezionatoContoDeposito(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_SET_RAPPORTO_SELEZIONATO_CONTO_DEPOSITO,
        payload: rapportoSelezionato,
    };
}
exports.setMovimentiSetRapportoSelezionatoContoDeposito = setMovimentiSetRapportoSelezionatoContoDeposito;
function setMovimentiSetOffset(offset) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_OFFSET,
        payload: offset,
    };
}
exports.setMovimentiSetOffset = setMovimentiSetOffset;
function setMovimentiListLoader(show) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_LIST_LOADER,
        payload: show,
    };
}
function setMovimentiSetDescrizione(txt) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_DESCRIZIONE,
        payload: txt,
    };
}
exports.setMovimentiSetDescrizione = setMovimentiSetDescrizione;
function setMovimentiSetDataDa(txt) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_DATA_DA,
        payload: txt,
    };
}
exports.setMovimentiSetDataDa = setMovimentiSetDataDa;
function setMovimentiSetDataA(txt) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_DATA_A,
        payload: txt,
    };
}
exports.setMovimentiSetDataA = setMovimentiSetDataA;
function setMovimentiSetCategorie(cats) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_CATEGORIE,
        payload: cats,
    };
}
exports.setMovimentiSetCategorie = setMovimentiSetCategorie;
function setMovimentiSetImporto(num) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_IMPORTO,
        payload: num,
    };
}
exports.setMovimentiSetImporto = setMovimentiSetImporto;
function setMovimentiSetPeriodo(txt) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_PERIODO,
        payload: txt,
    };
}
exports.setMovimentiSetPeriodo = setMovimentiSetPeriodo;
function setMovimentiSetEntrate(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_ENTRATE,
        payload: val,
    };
}
exports.setMovimentiSetEntrate = setMovimentiSetEntrate;
function setMovimentiSetUscite(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_USCITE,
        payload: val,
    };
}
exports.setMovimentiSetUscite = setMovimentiSetUscite;
function setMovimentiSetOrdinamento(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_ORDINAMENTO,
        payload: val,
    };
}
exports.setMovimentiSetOrdinamento = setMovimentiSetOrdinamento;
function setMovimentiSetMovimentiNonContabilizzati(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_MOVIMENTI_NON_CONTABILIZZATI,
        payload: val,
    };
}
exports.setMovimentiSetMovimentiNonContabilizzati = setMovimentiSetMovimentiNonContabilizzati;
function setMovimentiSetEntrateUscite(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_ENTRATE_USCITE,
        payload: val,
    };
}
exports.setMovimentiSetEntrateUscite = setMovimentiSetEntrateUscite;
function setMovimentiEntrataUscita(val) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_ENTRATA_USCITA,
        payload: val,
    };
}
exports.setMovimentiEntrataUscita = setMovimentiEntrataUscita;
function setMovimentiSetAccordionFiltriOpened(opened) {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_SET_ACCORDION_FILTRI_OPENED,
        payload: opened,
    };
}
exports.setMovimentiSetAccordionFiltriOpened = setMovimentiSetAccordionFiltriOpened;
/* get parametri carta conto - START */
function getParametriCartaContoStart() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_CARTA_CONTO_START,
    };
}
function getParametriCartaContoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_GET_PARAMETRI_CARTA_CONTO_SUCCESS,
        payload,
    };
}
const getParametriCartaConto = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriCartaContoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/parametri_movimenti.json")).then((parametri) => {
            dispatch(getParametriCartaContoSuccess((0, api_rest_1.ParametriMovimentiDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.MovimentiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriMovimentiCartaConto()
                .then((response) => {
                dispatch(getParametriCartaContoSuccess(response));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriCartaConto = getParametriCartaConto;
/* get parametri carta conto - FINE */
function getSaldoComplessivoStart() {
    return {
        type: __1.EReduxActionTypes.RAPPORTI_GET_SALDO_COMPLESSIVO_START,
    };
}
function getSaldoComplessivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RAPPORTI_GET_SALDO_COMPLESSIVO_SUCCESS,
        payload,
    };
}
const getSaldoComplessivo = (psd2in = false, showLoader = true) => async (dispatch, _, extraArguments) => {
    showLoader && dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getSaldoComplessivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require("../../mock/saldo_complessivo.json")).then((parametri) => {
            dispatch(getSaldoComplessivoSuccess((0, api_rest_1.SaldoDtoFromJSON)(parametri)));
        });
        showLoader && dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem("jwt").then((jwt) => {
            const request = {
                psd2in,
            };
            new api_rest_1.RapportiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .saldi(request)
                .then((response) => {
                dispatch(getSaldoComplessivoSuccess(response));
            })
                .catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            })
                .finally(() => {
                showLoader && dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getSaldoComplessivo = getSaldoComplessivo;
function resetMovimenti() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_RESET_MOVIMENTI,
    };
}
exports.resetMovimenti = resetMovimenti;
function resetSaldoEMovimenti() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_RESET_SALDO_E_MOVIMENTI,
    };
}
exports.resetSaldoEMovimenti = resetSaldoEMovimenti;
function resetFiltriMovimenti() {
    return {
        type: __1.EReduxActionTypes.SALDO_E_MOVIMENTI_RESET_FILTRI_MOVIMENTI,
    };
}
exports.resetFiltriMovimenti = resetFiltriMovimenti;
function rimuoviFiltriSaldoMovimenti() {
    return {
        type: __1.EReduxActionTypes.SALDO_MOVIMENTI_RIMUOVI_FILTRI,
    };
}
exports.rimuoviFiltriSaldoMovimenti = rimuoviFiltriSaldoMovimenti;
function rimuoviFiltriCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_RIMUOVI_FILTRI,
    };
}
exports.rimuoviFiltriCartaConto = rimuoviFiltriCartaConto;
function resetMovimentiHomepage() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_RESET_MOVIMENTI_HOMEPAGE,
    };
}
exports.resetMovimentiHomepage = resetMovimentiHomepage;
function setTipoElencoCartaConto() {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_SET_TIPO_ELENCO_CARTA_CONTO,
    };
}
exports.setTipoElencoCartaConto = setTipoElencoCartaConto;
function setTipoDivisaSelezionata(payload) {
    return {
        type: __1.EReduxActionTypes.MOVIMENTI_SET_TIPO_DIVISA_SELEZIONATA,
        payload,
    };
}
exports.setTipoDivisaSelezionata = setTipoDivisaSelezionata;
// PIN VIEW CARTA CONTO
//START START PIN VIEW SCA
function startPinViewScaStartCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_START_PIN_VIEW__SCA_START,
    };
}
function startPinViewScaSuccessCartaConto(payload) {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_START_PIN_VIEW__SCA_SUCCESS,
        payload,
    };
}
const startPinViewScaCartaConto = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(startPinViewScaStartCartaConto());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPinViewSCARequestDto: {
                id: cartaNexiId,
            },
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.CartaContoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPinViewSCASmartCard(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_SMART_CARD', 'GET_PIN_VIEW_SUCCESS_SMART_CARD');
                dispatch(startPinViewScaSuccessCartaConto(response));
            })
                .catch(async (error) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_SMART_CARD', `GET_PIN_VIEW_ERROR_SMART_CARD ${error.message}`);
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.startPinViewScaCartaConto = startPinViewScaCartaConto;
//END START PIN VIEW SCA
//START GET PIN VIEW
function getPinViewStartCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_GET_PIN_VIEW_START,
    };
}
function getPinViewSuccessCartaConto(payload) {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_GET_PIN_VIEW_SUCCESS,
        payload,
    };
}
const getPinViewCartaConto = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getPinViewStartCartaConto());
    if (extraArguments.mock) {
        dispatch(getPinViewSuccessCartaConto({
            content: "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",
            contentType: "image/svg+xml",
        }));
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const state = getState().movimenti;
        if (!((_a = state.startPinViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = state.startPinViewResponse) === null || _b === void 0 ? void 0 : _b.txId,
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.CartaContoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPinViewSmartCard(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPinViewSuccessCartaConto(response));
            })
                .catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getPinViewCartaConto = getPinViewCartaConto;
//END GET PIN VIEW
//PAN VIEW CARTA CONTO
function startPanViewScaStartCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_START_PAN_VIEW__SCA_START,
    };
}
function startPanViewScaSuccessCartaConto(payload) {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_START_PAN_VIEW__SCA_SUCCESS,
        payload,
    };
}
const startPanViewScaCartaConto = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(startPanViewScaStartCartaConto());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPanViewSCARequestDto: {
                id: cartaNexiId,
            },
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.CartaContoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPanViewSCASmartCard(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_SMART_CARD', 'GET_PAN_VIEW_SUCCESS_SMART_CARD');
                dispatch(startPanViewScaSuccessCartaConto(response));
            })
                .catch(async (error) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_SMART_CARD', `GET_PAN_VIEW_ERROR_SMART_CARD ${error.message}`);
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.startPanViewScaCartaConto = startPanViewScaCartaConto;
//START GET PAN VIEW
function getPanViewStartCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_GET_PAN_VIEW_START,
    };
}
function getPanViewSuccessCartaConto(payload) {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_GET_PAN_VIEW_SUCCESS,
        payload,
    };
}
const getPanViewCartaConto = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getPanViewStartCartaConto());
    if (extraArguments.mock) {
        dispatch(getPanViewSuccessCartaConto({
            content: "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",
            contentType: "image/svg+xml",
        }));
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const cartaConto = getState().movimenti;
        if (!((_a = cartaConto.startPanViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = cartaConto.startPanViewResponse) === null || _b === void 0 ? void 0 : _b.txId,
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.CartaContoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPanViewSmartCard(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPanViewSuccessCartaConto(response));
            })
                .catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getPanViewCartaConto = getPanViewCartaConto;
//END GET PAN VIEW
//COPY PAN VIEW
function copyPanViewSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_COPY_PAN_VIEW_SUCCESS,
        payload,
    };
}
exports.copyPanViewSuccess = copyPanViewSuccess;
const copyPanViewCartaConto = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    const cartaConto = getState().movimenti;
    if (!((_a = cartaConto.getPanViewResponse) === null || _a === void 0 ? void 0 : _a.content)) {
        dispatch((0, general_actions_1.setLoader)(false));
        return;
    }
    const getPinViewRequest = {
        body: (_b = cartaConto.getPanViewResponse) === null || _b === void 0 ? void 0 : _b.content
    };
    extraArguments.getItem("jwt").then((jwt) => {
        new api_rest_1.CartaContoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
            .getEncryptedSmartCardPanView(getPinViewRequest)
            .then(async (response) => {
            dispatch(copyPanViewSuccess(response));
        })
            .catch(async (error) => {
            try {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }
            catch (e) {
                console.log(e);
            }
        })
            .finally(() => {
            dispatch((0, general_actions_1.setLoader)(false));
        });
    });
};
exports.copyPanViewCartaConto = copyPanViewCartaConto;
//END COPY PAN VIEW
function resetPanViewCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_RESET_PAN_VIEW,
    };
}
exports.resetPanViewCartaConto = resetPanViewCartaConto;
function resetPinViewCartaConto() {
    return {
        type: __1.EReduxActionTypes.CARTA_CONTO_RESET_PIN_VIEW,
    };
}
exports.resetPinViewCartaConto = resetPinViewCartaConto;
